// Libraries
import React from 'react'

// Components
import {
  AlignItems,
  ComponentSize,
  FlexBox,
  FlexDirection,
  Grid,
  JustifyContent,
} from '@influxdata/clockface'

// Types
import {Auth0Connection} from 'js/types'
import MicrosoftSocialButton from './MicrosoftSocialButton'
import GoogleSocialButton from './GoogleSocialButton'

interface Props {
  handleSocialClick: (connection: Auth0Connection) => void
}

const SocialSignupButtonsHeader = ({handleSocialClick}: Props): JSX.Element => (
  <Grid>
    <FlexBox
      stretchToFitWidth={true}
      direction={FlexDirection.Column}
      justifyContent={JustifyContent.Center}
      alignItems={AlignItems.Center}
      margin={ComponentSize.Large}
    >
      <GoogleSocialButton handleSocialClick={handleSocialClick} />
      <MicrosoftSocialButton handleSocialClick={handleSocialClick} />
    </FlexBox>
  </Grid>
)

export default SocialSignupButtonsHeader
